import React from "react";
import { Modal } from "../../../../Components";
import { Card, Text, Box } from "rebass";
import VividVisionSettings from "../../../../VividVisionSettings.json";

export const AddGameModal: React.FC<{
  isOpen: boolean;
  setIsOpen: (b: boolean) => void;
}> = ({ isOpen, setIsOpen }) => {
  return (
    <Modal headerText="Add a game" isOpen={isOpen} setIsOpen={setIsOpen}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: ["1fr", "1fr 1fr", "1fr 1fr 1fr"],
          columnGap: 3,
        }}
      >
        {Object.keys(VividVisionSettings).map((key) => (
          <Card key={key}>
            <Text
              padding={3}
              fontWeight="bold"
              fontSize="28"
              textAlign="center"
            >
              {key}
            </Text>
          </Card>
        ))}
      </Box>
    </Modal>
  );
};
